import { Theme } from '@mui/material';
import { TEDBOAktivitetTypEnum } from '../../../../globalQueryTypes';

export const themeColor = (
  akttyp: string | TEDBOAktivitetTypEnum | undefined
) => akttyp?.toLowerCase();

export const aktivitetColors = (
  typ: TEDBOAktivitetTypEnum | undefined,
  prelbokad: boolean,
  bokningsbar: boolean,
  theme: Theme
): [string | undefined, string | undefined, string | undefined] => {
  const aktivitetColorName = themeColor(typ);
  const aktivitetColorsObj = theme.customProperties?.AktivitetColors as unknown as Record<string, string>;
  const preliminaryBorderColor = aktivitetColorName
    ? aktivitetColorsObj?.[aktivitetColorName]
    : (theme.customProperties?.AktivitetColors?.preliminarNyVy.light as unknown as Record<string, string>)?.[aktivitetColorName ?? ''];
  const aktivitetColor =
    aktivitetColorName
    ? (bokningsbar
      ? (theme.customProperties?.AktivitetColors.bokningsbar as unknown as Record<string, string>)[aktivitetColorName]
      : aktivitetColorsObj?.[aktivitetColorName])
    : undefined;
  const prelAktivitetBackground =
    prelbokad && aktivitetColorName
      ? (theme.customProperties?.AktivitetColors?.preliminarNyVy.light as unknown as Record<string, string>)[
          aktivitetColorName
        ]
      : undefined;
  return [aktivitetColor, prelAktivitetBackground, preliminaryBorderColor];
};
